import type {DalValue} from '@wix/document-services-types'
import _ from 'lodash'

export const DEPENDENCY_INFO_FIELDS: Record<string, string[]> = {
    BreakpointRange: ['min', 'max', 'canvasSize']
}

export const getInfoForItem = (item: DalValue): Record<string, unknown> | undefined => {
    if (!item?.type) {
        return undefined
    }

    const fields = DEPENDENCY_INFO_FIELDS[item.type]
    if (!fields) {
        return undefined
    }

    return _.pick(item, fields)
}
